$.fn.InvoiceForm = function()	// extends Form
{
	_form = this;
	_form.element_list = undefined;
	_form.calculator = undefined;

	_form.getInvoiceID = function()
	{
		return parseInt(_form.element.find("input[name=id]").val(), 10);
	};

	_form.get_contact_id = function()
	{
		return parseInt(_form.element.find("select[name=contact_id]").val(), 10);
	};

	_form.get_invoice_type = function()
	{
		return parseInt(_form.element.find("input[name=type]").val(), 10);
	};

	_form.get_redevance = function()
	{
		return parseFloat(_form.element.find("input[name=redevance]").val(), 10);
	};

	_form.updateTotals = function()
	{
		if (_form.element_list != undefined) {
			if (_form.get_invoice_type() == 3) {	// prod
				var total_amount = 0;
				_form.element_list.model.each(function(element){
					total_amount += element.getTotal();
				});
				total_amount = total_amount.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
				_form.find(".cell-total-amount").html(total_amount);
			} else {
				var total_received = 0,
				total_due = 0;
				_form.element_list.model.each(function(element){
					total_received += element.getTotal();
					total_due += element.getTotalDue();
				});
				total_received = total_received.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
				total_due = total_due.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
				_form.find(".cell-total-received").html(total_received);
				_form.find(".cell-total-due").html(total_due);
				_form.calculator.setFee(total_received);
			}
		}
	};

	/* Form saved: overridden from form */
	_form.saved = function(x)
	{
		_form.adding = false;
		_form.element_list.model.each(function(element){
			element.interface.tabs.details.details_list.model.details.forEach(function(details_item){
				details_item.update();
			});
		});

		/* Update str_id */
		if ('extra' in x && 'str_id' in x.extra) {
			$('input[name="str_id"]').val(x.extra.str_id)
			$('.invoice-strid').text(x.extra.str_id)
		}
	};

	_form.updateItems = function() {
		_form.element_list.model.elements.forEach(function(_e) {
			var details_items = _e.interface.tabs.details.details_list.model.details;
			details_items.forEach(function(_item) {
				_item.updateItemFees();
				_item.save();
			});
		});
	};

	_form.autoSave = function() {
		var currentAction = $('input[name=action]').val();
		if (currentAction == 'edit') {
			$('.btn-action-submit').click();
		}
	};

	_form.strid_clicked = function() {
		var new_strid = prompt('Veuillez entrer le nouveau numéro de facture.', $(this).attr('data-hole-strid'));
		if (new_strid) {
			$('input[name="str_id"]').val(new_strid).trigger('change')
			$(this).text(new_strid).off('click').removeClass('text-red')
		}
	}

	_form.sartec_changed = function() {
		let self = $(this),
		other = $(this).attr('name') == 'sartec' ? $('input[name="sartec_tv"]') : $('input[name="sartec"]');
		if (self.is(':checked')) {
			other.prop('checked', false)
		}
	}

	return function()
	{
		/* Date time picker */
		var dateTimePicker = _form.find('.invoice-date-picker').datetimepicker({
			widgetPositioning: {
				horizontal: 'left'
			},
			icons: {
				time: "fa fa-clock-o",
				date: "fa fa-calendar",
				up: "fa fa-arrow-up",
				down: "fa fa-arrow-down",
				previous: 'fa fa-arrow-left',
				next: 'fa fa-arrow-right'
			},
			format: 'DD/MM/YYYY',
			locale: 'fr-ca'
		});
		dateTimePicker.on("dp.change", function(){
			_form.autoSave();
		});

		// Update invoice string_id
		$('.invoice-strid').on('click', _form.strid_clicked);

		// Calculatrice
		_form.calculator = _form.find(".slr-calc").Calculator();

		// Elements list
		_form.element_list = _form.find("#slr-element-list").ElementList(_form);

		// Change redevance, calc again
		_form.element.find("input[name=redevance]").on("change", _form.updateItems);

		// Sartec only one selected
		_form.element.find("input[name=sartec],input[name=sartec_tv]").on("change", _form.sartec_changed);

		// Auto-save for invoice form
		_form.find('input[name=date]').on("change", _form.autoSave);
		_form.element.on("change", _form.autoSave);

		// Contact & reference
		_form.find("#form-invoice-contact-reference").ContactReferenceModule();

		// Update totals
		_form.updateTotals();

		// Return
		return _form;
	}();
}

$.fn.ContactReferenceModule = function()
{
	var self = this;
	self.fields = {
		contact : self.find('select[name=contact_id]'),
		invoiced : self.find('textarea[name=invoiced]'),
		reference : self.find('input[name=reference]')
	};

	self.current_contact_id = function()
	{
		return self.fields.contact.select2('val');
	};

	return function()
	{
		// auto complete on reference field
		$.typeahead({
			input: 'input[name=reference]',
			order: 'asc',
			minLength: 0,
			accent: true,
			dynamic: true,
			searchOnFocus: true,
			source: {
				ajax: {
					url: "/facture/references/",
					data: {
						contact_id: self.current_contact_id
					}
				}
			},
			cancelButton: false
		});

		// focus sur le champ suivant: Facturé à sur une facture externe, sinon la référence
		self.fields.contact.on("change", function(){
			setTimeout(function(){
				if (self.fields.invoiced.length){
					self.fields.invoiced.focus();
				} else {
					self.fields.reference.focus().select();
				}
			}, 1);
		});

		// nouvelle facture: focus sur la référence, ou sur Payable à pour une facture externe sans destinataire
		var currentAction = $('input[name=action]').val();
		if (currentAction == 'add') {
			if (self.fields.invoiced.length && !self.fields.contact.val()){
				self.fields.contact.next('.select2').find('.select2-selection').focus();
			} else if (self.fields.invoiced.length){
				self.fields.invoiced.focus();
			} else {
				self.fields.reference.focus().select();
			}
		}
		return self;
	}();
};
